/**
 * Formats file size from bytes to MB
 */
export const formatFileSize = (bytes: number): string => {
  return `${Math.round(bytes / (1024 * 1024))} MB`;
};

/**
 * Formats date string to locale date
 */
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString();
};

/**
 * Video sorting utility function
 */
export const sortVideos = (videos: any[], sortBy: string) => {
  const sortedVideos = [...videos];
  
  switch (sortBy) {
    case 'recent':
      return sortedVideos.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    case 'oldest':
      return sortedVideos.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
    case 'largest':
      return sortedVideos.sort((a, b) => b.file_size - a.file_size);
    case 'smallest':
      return sortedVideos.sort((a, b) => a.file_size - b.file_size);
    case 'user_asc':
      return sortedVideos.sort((a, b) => (a.user_email || '').localeCompare(b.user_email || ''));
    case 'user_desc':
      return sortedVideos.sort((a, b) => (b.user_email || '').localeCompare(a.user_email || ''));
    default:
      return sortedVideos;
  }
};
